import { CheckboxStateValue } from 'common/hooks';

export const arrayToCheckboxState = (array: (string | number)[]): CheckboxStateValue => (
  array.reduce((acc, value) => ({ ...acc, [value]: true }), {})
);
